import PersistStorage from "./PersistStorage";
import APICom from "./APICom";

class ModuleSecurity {
    static ModulesArray = [];
    static CheckModuleSecurityByTag(Tag) {
        try {
            try{
                if(this.ModulesArray === null || this.ModulesArray.length === 0) {
                    let _moduleSecurity = PersistStorage.retrieve("UserModuleList", false);
                    if(typeof _moduleSecurity !== "undefined") {
                        if(_moduleSecurity != null){
                            this.ModulesArray = _moduleSecurity;
                        }
                    }
                }
            }
            catch(e) { 
                return true;
            }
            if(this.ModulesArray != null && this.ModulesArray.length > 0) {
                // Check if 'array' is actually an array and not undefined or null
                if (!Array.isArray(this.ModulesArray)) {
                    console.error('The provided value is not an array.');
                    return false;
                }

                // Use 'some' to check for the existence of an object with the matching 'vTag'
                return this.ModulesArray.some(function(element) {
                    // Ensure 'element' is an object and has the 'vTag' property
                    return typeof element === 'object' && element !== null && element.vTag.toUpperCase() === Tag.toUpperCase();
                });
            }
            else{
                return true;
            }
        } 
        catch (e) {
        }
        return false;
    }

    static async FetchAndSaveUserAssignedModules(iUserID, iUserRecordID) {
        const data = {
            "iUserID": iUserID,
            "iRecordID": iUserRecordID
        }
        try
        {
            const response = await APICom.fetchData("main", "AuthActions/GetUserModuleList", "post", {}, data);
            if (response.error !== "") {
                PersistStorage.save("UserModuleList", [], 999, false);
            }
            else 
            {
                PersistStorage.save("UserModuleList", response.data, 999, false);
            }    
        }catch(e)
        {
            console.log(e);
        }
    }
    static async PowerUserModules(iUserID, iUserRecordID) {
        const data = {
            "iUserID": iUserID,
            "iRecordID": iUserRecordID
        }
        try
        {
            this.ModulesArray = [];
            PersistStorage.save("UserModuleList", [], 999, false);  
        }
        catch(e)
        {
            console.log(e);
        }
    }
};

export default ModuleSecurity;